import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import ImageHero from "../components/ImageHero"
import SliceZone from "../components/SliceZone"
import { withPreview } from "gatsby-source-prismic"
// import { useLocation } from "@reach/router"

const Page = ({
  // doc,
  location,
  data: {
    page,
    events,
    faq,
    allpages,
    gallery,
    steps,
    callouts,
    team,
    donate_form,
  },
}) => {
  // const location = useLocation()
  const isDonation = location.pathname === "/donate"

  return (
    <>
      <Helmet
        bodyAttributes={{
          class: `page ${page.uid}`,
        }}
      />
      <ImageHero
        page={page}
        video={page.data.video.url}
        title={page.data.page_title.text}
        // text={page.data.page_description.text}
        // donationForm={page.data.show_donation_form ? "true" : "false"}
      />

      <SliceZone
          slices={page.data.body}
          page={page}
          allpages={allpages}
          faq={faq}
          events={events}
          gallery={gallery}
          steps={steps}
          callouts={callouts}
          team={team}
          donate_form={donate_form}
        />
      {/* <h1>{isDonation ? ( <p>True</p> ) : (<p>fa</p>)}</h1> */}

      {/* {isDonation ? (
        <div className="donate-wrap">
          <div class="donate-wrap__left">
            <div className="donate-sidebar">
              <h3>Donate</h3>
              <a href="#">Donating is easy</a>
              <a href="#">General donations</a>
              <a href="#">Donate to one of our upcoming events</a>
            </div>
          </div>
          <div className="donate-wrap__right">
            <SliceZone
              slices={page.data.body}
              page={page}
              allpages={allpages}
              faq={faq}
              events={events}
              gallery={gallery}
              steps={steps}
              callouts={callouts}
              team={team}
              donate_form={donate_form}
            />
          </div>
        </div>
      ) : (
        <SliceZone
          slices={page.data.body}
          page={page}
          allpages={allpages}
          faq={faq}
          events={events}
          gallery={gallery}
          steps={steps}
          callouts={callouts}
          team={team}
          donate_form={donate_form}
        />
      )} */}
    </>
  ) 
}

export default withPreview(Page)

export const pageQuery = graphql`
  query PageBySlug($uid: String!) {
    page: prismicPage(uid: { eq: $uid }) {
      id
      uid
      prismicId
      data {
        page_description {
          text
        }
        page_title {
          text
        }
        show_donation_form
        video {
          url
        }
        body {
          ... on PrismicPageBodySiteInfo {
            id
            slice_type
            primary {
              text {
                text
              }
              image {
                url
              }
            }
          }
          ... on PrismicPageBodyEvents {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicPageBodyGallerySlider {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicPageBodySteps {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicPageBodyTeam {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicPageBodyCallouts {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicPageBodyDonateForm {
            id
            slice_type
            primary {
              title {
                text
              }
              blurb {
                text
              }
            }
          }
          ... on PrismicPageBodyFaq {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicPageBodyMarquee {
            id
            slice_type
            items {
              text {
                text
              }
            }
          }
        }
      }
    }
    allpages: allPrismicPage {
      nodes {
        data {
          body {
            ... on PrismicPageBodySiteInfo {
              id
              slice_type
              primary {
                image {
                  url
                }
                text {
                  text
                }
              }
            }
            ... on PrismicPageBodyEvents {
              id
              slice_type
              primary {
                title {
                  text
                }
              }
            }
            ... on PrismicPageBodyGallerySlider {
              id
              slice_type
              primary {
                title {
                  text
                }
              }
            }
            ... on PrismicPageBodySteps {
              id
              slice_type
              primary {
                title {
                  text
                }
              }
            }
            ... on PrismicPageBodyTeam {
              id
              slice_type
              primary {
                title {
                  text
                }
              }
            }
            ... on PrismicPageBodyCallouts {
              id
              slice_type
              primary {
                title {
                  text
                }
              }
            }
            ... on PrismicPageBodyFaq {
              id
              slice_type
              primary {
                title {
                  text
                }
              }
            }
            ... on PrismicPageBodyDonateForm {
              id
              slice_type
              primary {
                title {
                  text
                }
                blurb {
                  text
                }
              }
            }
            ... on PrismicPageBodyMarquee {
              id
              slice_type
              items {
                text {
                  text
                }
              }
            }
          }
        }
      }
      edges {
        node {
          data {
            body {
              ... on PrismicPageBodySiteInfo {
                id
                slice_type
                primary {
                  text {
                    text
                  }
                  image {
                    url
                  }
                }
              }
              ... on PrismicPageBodyEvents {
                id
                slice_type
                primary {
                  title {
                    text
                  }
                }
              }
              ... on PrismicPageBodySteps {
                id
                slice_type
                primary {
                  title {
                    text
                  }
                }
              }
              ... on PrismicPageBodyTeam {
                id
                slice_type
                primary {
                  title {
                    text
                  }
                }
              }
              ... on PrismicPageBodyCallouts {
                id
                slice_type
                primary {
                  title {
                    text
                  }
                }
              }
              ... on PrismicPageBodyFaq {
                id
                slice_type
                primary {
                  title {
                    text
                  }
                }
              }
              ... on PrismicPageBodyDonateForm {
                id
                slice_type
                primary {
                  title {
                    text
                  }
                  blurb {
                    text
                  }
                }
              }
              ... on PrismicPageBodyMarquee {
                id
                slice_type
                items {
                  text {
                    text
                  }
                }
              }
            }
          }
        }
      }
    }
    events: allPrismicEvent(
      sort: { fields: [first_publication_date], order: DESC }
    ) {
      nodes {
        data {
          title {
            text
          }
          video {
            url
          }
          text {
            text
          }
          featured_image {
            url
          }
          date(formatString: "MM-DD-YY")
        }
        url
        uid
        id
        first_publication_date
      }
    }
    faq: prismicFaq {
      data {
        group {
          answer {
            text
          }
          question {
            text
          }
        }
      }
    }
    gallery: prismicGallery {
      id
      data {
        group {
          image {
            thumbnails {
              Mobile {
                url
                alt
              }
              Desktop {
                url
                alt
              }
              Tablet {
                url
                alt
              }
            }
            url
          }
          caption {
            text
          }
        }
        title {
          text
        }
      }
    }
    steps: prismicSteps {
      data {
        group {
          image {
            url
          }
          text {
            text
          }
          title {
            text
          }
        }
      }
    }
    callouts: prismicCallouts {
      data {
        group {
          title {
            text
          }
          link {
            slug
          }
          image {
            url
          }
          cta {
            text
          }
        }
      }
    }
    donate_form: prismicDonateForm {
      id
      data {
        title {
          text
        }
        blurb {
          text
        }
      }
    }
    team: allPrismicTeamMembers(
      sort: { fields: [first_publication_date], order: ASC }
    ) {
      nodes {
        uid
        url
        first_publication_date(formatString: "MM DD YY")
        last_publication_date(formatString: "MM DD YY")
        data {
          name {
            text
          }
          bio {
            text
          }
          image {
            url
          }
          position {
            text
          }
        }
      }
    }
  }
`
